import React from "react";

/** The date rendered as an editorial three-column line: weekday · day · month-year. */
export function DateBlock({ weekday, day, monthYear, time, tone = "default", style }) {
  const fg = tone === "onDark" ? "var(--fg-on-contrast)" : "var(--fg-primary)";
  const rule = tone === "onDark" ? "color-mix(in srgb, var(--fg-on-contrast) 30%, transparent)" : "var(--rule)";
  const side = { fontFamily: "var(--font-display)", fontStyle: "italic", fontSize: "var(--fs-title-s)", color: fg, whiteSpace: "nowrap" };
  return (
    <div style={{ display: "grid", justifyItems: "center", gap: "var(--sp-3)", ...style }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "var(--sp-4)" }}>
        <span style={side}>{weekday}</span>
        <span style={{ width: 1, height: 52, background: `linear-gradient(180deg, transparent, ${rule}, transparent)` }} />
        <span style={{ fontFamily: "var(--font-title, var(--font-display))", fontSize: "var(--fs-display-l)", fontWeight: "var(--fw-light)", lineHeight: 1, color: fg }}>{day}</span>
        <span style={{ width: 1, height: 52, background: `linear-gradient(180deg, transparent, ${rule}, transparent)` }} />
        <span style={side}>{monthYear}</span>
      </div>
      {time && <p style={{ margin: 0, fontFamily: "var(--font-display)", fontStyle: "italic", fontSize: "var(--fs-body-l)", color: "var(--accent)" }}>{time}</p>}
    </div>
  );
}
